import React from "react";
import Image from "next/image";
import { AspectRatio, Flex, Text } from "@chakra-ui/react";
import { Button } from "ui/button";
import { Card } from "ui/cards";

type QuoteCardProps = {
  bg: string;
  logo: string;
  quote: string;
  author: string;
  job: string;
  company: string;
  href: string;
};

export function QuoteCard({ bg, logo, quote, author, job, company, href }: QuoteCardProps) {
  return (
    <Card
      variant="shadow"
      mediaRatio={3 / 2}
      mb="0"
      title={
        <>
          <Text textStyle="body3" fontWeight="normal">
            “{quote}”
          </Text>

          <Text textStyle="caption1" fontWeight="bold" mt="small">
            {author}
            <br />
            <Text as="span" fontWeight="normal">
              {job} at {company}
            </Text>
          </Text>
        </>
      }
      titleAs="div"
      media={
        <Flex bg={bg}>
          <AspectRatio ratio={195 / 50} w="195px" maxW="80%" maxH="42px">
            <Image
              width="195"
              height="42"
              src={logo + "?w=400"}
              alt={`${company} logo.`}
              style={{
                objectFit: "contain",
                objectPosition: "center",
                filter: "brightness(0) invert(1)",
              }}
            />
          </AspectRatio>
        </Flex>
      }
      actions={
        <Button hasRightChevron href={href}>
          Read case study
        </Button>
      }
    />
  );
}
